module.exports = __webpack_public_path__ + "static/img/gold_bg6.3af3320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/gold_bg6.png
// module id = /7Bp
// module chunks = 1